import { Col, Row, Stack } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faChartBar,
  faCircle,
  faClipboardCheck,
  faSquare,
  faUser,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';
import { Props } from './stats.type';
import { useMemo } from 'react';

type StatType = {
  id: number | string;
  icon: IconProp;
  title: string;
  subTitle: string;
  color: string;
};

const Stats = ({ statsDetails }: Props) => {
  const statsList: StatType[] = useMemo(() => {
    return [
      {
        id: 1,
        icon: faUser,
        title: `${statsDetails?.students || 0} Students`,
        subTitle: 'Total registered students',
        color: 'warning'
      },
      {
        id: 2,
        icon: faChartBar,
        title: `${statsDetails?.activeAssessment || 0} Active Assessments`,
        subTitle: 'Ongoing skill tests',
        color: 'success'
      },
      {
        id: 3,
        icon: faClipboardCheck,
        title: `${
          statsDetails?.completedAssessment || 0
        } Completed Assessments`,
        subTitle: 'Finished assessments',
        color: 'info'
      },
      {
        id: 4,
        icon: faUserTie,
        title: `${statsDetails?.engagementRate || 0}% Engagement`,
        subTitle: 'Student engagement rate',
        color: 'danger'
      }
    ];
  }, [statsDetails]);
  return (
    <Row className="align-items-center g-4">
      {statsList?.map(stat => (
        <Col xs={12} md="auto" key={stat.id}>
          <Stat stat={stat} />
        </Col>
      ))}
    </Row>
  );
};

const Stat = ({ stat }: { stat: StatType }) => {
  return (
    <Stack direction="horizontal" className="align-items-center">
      {/* <img src={stat.icon} alt="" height={46} width={46} /> */}
      <span
        className="fa-layers"
        style={{ minHeight: '46px', minWidth: '46px' }}
      >
        <FontAwesomeIcon
          icon={faSquare}
          size="2x"
          className={`text-${stat.color}-light dark__text-opacity-50`}
          transform="down-4 rotate--10 left-4"
        />
        <FontAwesomeIcon
          icon={faCircle}
          size="2x"
          className={`text-stats-circle-${stat.color} fa-layers-circle`}
          transform="up-4 right-3 grow-2"
        />
        <FontAwesomeIcon
          icon={stat.icon}
          size="1x"
          className={`text-${stat.color}`}
          transform="shrink-2 up-8 right-6"
        />
      </span>

      <div className="ms-3">
        <h4 className="mb-0">{stat.title}</h4>
        <p className="text-body-secondary fs-9 mb-0">{stat.subTitle}</p>
      </div>
    </Stack>
  );
};

export default Stats;
